import { Directive, ElementRef, afterNextRender, inject, input } from '@angular/core';

export type AutofocusMode = boolean | 'selectAll';

@Directive({
  selector: '[autofocusOnRender]',
  standalone: true,
})
export class AutofocusOnRenderDirective {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  public $mode = input<AutofocusMode>(false, { alias: 'autofocusOnRender' });

  private _fired = false;

  public constructor() {

    afterNextRender(() => {

      // Only auto-focus once per directive lifetime — don't re-grab focus on
      // subsequent re-renders (e.g. when navigating into a subpanel and back).
      if (this._fired) return;

      const mode = this.$mode();
      if (!mode) return;

      this._fired = true;
      const el = this.elementRef.nativeElement;
      el.focus();

      if (mode === 'selectAll' && 'select' in el && typeof (el as HTMLInputElement).select === 'function') {
        (el as HTMLInputElement).select();
      }
    });
  }
}
